import { lazy } from 'react'

export const RadioQuestion = lazy(() => import('./RadioQuestion'))
